module.exports = __webpack_public_path__ + "media/images/desktop/seen_status-83a48e5a12c2d2d174040eb0e2cc3066.svg";